import { Kernrecht } from '../kernrecht/kernrecht.model';
export class Kerngruppe {
  id: string;
  kernRechte: Kernrecht[];
  sprachschluessel: string;
  md2DataTableSort_Sprachschluessel: string;
}
